import axios from '../components/shared/axios';
const baseURL = process.env.REACT_APP_BACKEND_URL;

export const uploadImage = async (payload) => {
  return await axios.post(`${baseURL}/uploadImage`, payload);
};

export const uploadHtml = async (payload) => {
  console.log('payload');
  return await axios.post(`${baseURL}/uploadHtml`, payload);
};
